export default __webpack_public_path__ + "static/flag-nl-7aec4025166a052468db53f7cdbe3340.svg";